import { z } from 'zod';

/**
 * Exclusão pelo administrador master (ADR 0051): a tabela ("schema.tabela") e o registro. A prévia
 * diz o que sai junto; a exclusão exige o motivo.
 */
export const masterPurgeTargetInput = z.object({
  table: z.string().regex(/^[a-z_]+\.[a-z_]+$/, 'Tabela inválida'),
  id: z.uuid(),
});

export const masterPurgeInput = masterPurgeTargetInput.extend({
  reason: z
    .string()
    .trim()
    .min(5, 'Informe o motivo da exclusão (pelo menos 5 letras)')
    .max(500, 'Motivo longo demais (até 500 letras)'),
});

export type MasterPurgeInput = z.infer<typeof masterPurgeInput>;

/** Quantos registros de cada tabela saem (ou sairiam, na prévia). */
export interface MasterPurgeResult {
  total: number;
  tables: { table: string; records: number }[];
}
